import * as Yup from 'yup';
import { AnyObject, TestContext, ValidationError } from 'yup';
import { validateSn } from './snValidationScheme';

export const originalValidationSchemeCustomer = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>,
  produktionsdatumRequired: boolean,
  pinRequired: boolean
) =>
  Yup.object({
    sn: validateSn(checkSn),
    imo_nr: Yup.number().required('This field is required'),
    schiffsname: Yup.string().required('This field is required'),
    email: Yup.string().required('This field is required'),
    produktionsdatum: produktionsdatumRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    commissioning_date: Yup.string().required('This field is required'),
    pin: pinRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    sn_partner: Yup.number().optional(),
  });

export const originalValidationSchemeAgent = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>,
  produktionsdatumRequired: boolean,
  pinRequired: boolean
) =>
  Yup.object({
    sn: validateSn(checkSn),
    sn_partner: Yup.number().optional(),
    pin: pinRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    produktionsdatum: produktionsdatumRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    imo_nr: Yup.number().required('This field is required'),
    schiffsname: Yup.string().required('This field is required'),
    commissioning_date: Yup.string().required('This field is required'),
  });
